import React from 'react'
import Application from '../components/Applications/Index'

const Applications = () => {
  return (
    <div className='container mx-auto'><Application/></div>
  )
}

export default Applications